/* import __COLOCATED_TEMPLATE__ from './notification-preferences.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _processScreens, _populateUnitNotificationPreferences;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { Flow } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/flow';
import { ScreenContainer } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/model';
import { UiElement } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/ui_element';
import { WorkflowRequest } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/service';
import assert, { assertInstanceOf } from '@banking/ui/utils/assert';
import { PhoneFormatter } from 'field-kit';
import { UnitNotificationPreferences } from '@square/dashboard-protos/models/squareup/bbfrontend/v1/unit_notification_preferences';
// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';

// NOTE(cvu): recursively remove readonly from mapped value properties.
// This might be useful somewhere else but commonly can be found in the
// typescript documentation

const phoneFormatter = new PhoneFormatter();
export let NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType["FRAUD"] = "NOTIFICATION_TYPE_FRAUD_ALERT";
  NotificationType["DECLINED"] = "NOTIFICATION_TYPE_DECLINED_TRANSACTION";
  NotificationType["CNP"] = "NOTIFICATION_TYPE_CNP_TRANSACTION";
  NotificationType["INTERNATIONAL"] = "NOTIFICATION_TYPE_INTERNATIONAL_TRANSACTION";
  return NotificationType;
}({});
export let NotificationChannel = /*#__PURE__*/function (NotificationChannel) {
  NotificationChannel["EMAIL"] = "NOTIFICATION_CHANNEL_EMAIL";
  NotificationChannel["SMS"] = "NOTIFICATION_CHANNEL_SMS";
  return NotificationChannel;
}({});

/**
 * FIXME(cvu): THIS IS BAD! These strings are from bb-frontend. If they change tracking will inaccurate!
 */
const getNotificationPreferencesForTracking = notificationTypeValueMap => {
  if (!notificationTypeValueMap) {
    return {};
  }
  const getChannelTrackingValues = (prefix, values) => {
    return Object.entries(values).map(([channel, value]) => {
      if (channel === NotificationChannel.EMAIL) {
        return [`${prefix}Email`, value];
      }
      return [`${prefix}Sms`, value];
    });
  };
  return Object.fromEntries(Object.entries(notificationTypeValueMap).reduce((acc, [type, {
    value
  }]) => {
    switch (type) {
      case NotificationType.FRAUD:
        acc.push(...getChannelTrackingValues('fraud', value));
        break;
      case NotificationType.DECLINED:
        acc.push(...getChannelTrackingValues('declined', value));
        break;
      case NotificationType.CNP:
        acc.push(...getChannelTrackingValues('online', value));
        break;
      case NotificationType.INTERNATIONAL:
        acc.push(...getChannelTrackingValues('international', value));
        break;
    }
    return acc;
  }, []));
};
let NotificationPreferences = (_class = (_processScreens = /*#__PURE__*/new WeakSet(), _populateUnitNotificationPreferences = /*#__PURE__*/new WeakSet(), class NotificationPreferences extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _populateUnitNotificationPreferences);
    _classPrivateMethodInitSpec(this, _processScreens);
    _initializerDefineProperty(this, "balancesWorkflowApi", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "emberMultipassfeClient", _descriptor6, this);
    _initializerDefineProperty(this, "loading", _descriptor7, this);
    _initializerDefineProperty(this, "buttonLoading", _descriptor8, this);
    _initializerDefineProperty(this, "loadingError", _descriptor9, this);
    _initializerDefineProperty(this, "showSecureContactModal", _descriptor10, this);
    _initializerDefineProperty(this, "email", _descriptor11, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor12, this);
    _initializerDefineProperty(this, "employmentToken", _descriptor13, this);
    _initializerDefineProperty(this, "notificationTypeOrder", _descriptor14, this);
    _initializerDefineProperty(this, "notificationChannelOrder", _descriptor15, this);
    _initializerDefineProperty(this, "notificationTypeTexts", _descriptor16, this);
    _initializerDefineProperty(this, "notificationChannelTexts", _descriptor17, this);
    // Mutable version to be used to save
    _initializerDefineProperty(this, "unitNotificationPreferencesValues", _descriptor18, this);
    _initializerDefineProperty(this, "unitNotificationPreferencesConfig", _descriptor19, this);
    _initializerDefineProperty(this, "banners", _descriptor20, this);
    _defineProperty(this, "SECURE_CONTACT_T_PREFIX", 'ember_personal_settings.multipass_components_addon.');
    // FIXME(cvu): Maybe turn this into a ember helper? Or reusable const to import for bb-frontend stuff
    _defineProperty(this, "bannerStyleMap", {
      [UiElement.BannerElement.BannerStyle.INFO]: 'info',
      [UiElement.BannerElement.BannerStyle.SUCCESS]: 'success',
      [UiElement.BannerElement.BannerStyle.WARNING]: 'warning',
      [UiElement.BannerElement.BannerStyle.CRITICAL]: 'critical',
      // NOTE(cvu): Dashboard does not have specific banner style for insight. Using info.
      [UiElement.BannerElement.BannerStyle.INSIGHT]: 'info'
    });
    // bb-frontend context. Used to make request back to bb-frontend
    _defineProperty(this, "context", undefined);
  }
  get notificationTypeValue() {
    return this.unitNotificationPreferencesValues?.notificationTypeValue;
  }
  get formattedPhoneNumber() {
    // NOTE(cvu): formatting phone number instead of adding field kit to input since the value is readonly
    return phoneFormatter.format(this.phoneNumber);
  }
  get showNotificationPreferencesContent() {
    return Boolean(this.unitNotificationPreferencesValues);
  }
  async initialize() {
    this.loading = true;
    this.showSecureContactModal = false;
    try {
      const {
        unitToken
      } = this.args;
      assert(typeof unitToken === 'string');
      const request = WorkflowRequest.create({
        flow: Flow.create({
          unitNotificationPreferences: Flow.UnitNotificationPreferencesFlow.create({
            unitToken
          })
        }),
        screens: []
      });
      await _classPrivateMethodGet(this, _populateUnitNotificationPreferences, _populateUnitNotificationPreferences2).call(this, request);
    } catch (e) {
      this.sentry.captureException(e);
      this.loadingError = true;
    }
    this.loading = false;
  }
  retryInitialize() {
    this.loadingError = false;
    this.initialize();
  }
  onEditEmailClick() {
    const url = this.router.urlFor('user_settings');
    theWindow.open(url, '_blank', 'noopener,noreferrer');
    this.dataApi.track('Click Checking Notifications', {
      feature: 'Checking Notifications',
      applet: 'Banking',
      page: 'Notifications',
      target: 'Edit Email',
      unitToken: this.args.unitToken
    });
  }
  onEditPhoneClick() {
    if (this.employmentToken) {
      const url = this.router.urlFor('team.team_members.edit', this.employmentToken);
      theWindow.open(url, '_blank', 'noopener,noreferrer');
    } else {
      // Cache the secure contact details so that they can be used downstream.
      this.emberMultipassfeClient.listSecureContact();
      this.showSecureContactModal = true;
    }
    this.dataApi.track('Click Checking Notifications', {
      feature: 'Checking Notifications',
      applet: 'Banking',
      page: 'Notifications',
      target: 'Edit Phone Number',
      unitToken: this.args.unitToken
    });
  }
  onPreferenceChange(type, channel, event) {
    if (event.type !== 'marketCheckboxValueChange') {
      throw new Error("Action only supported for 'marketCheckboxValueChange' event");
    }
    if (!this.unitNotificationPreferencesValues || !this.unitNotificationPreferencesConfig) {
      throw new Error('unitNotificationPreferencesValues or unitNotificationPreferencesValues is undefined');
    }
    if (!this.unitNotificationPreferencesConfig.notificationTypeConfig[type].isEnabled[channel]) {
      throw new Error('Trying to set value for not enabled notification preferences');
    }
    this.unitNotificationPreferencesValues.notificationTypeValue[type].value[channel] = event.detail.current === true;

    // NOTE(cvu): Tracked values are shallow and to update the nested values,
    // unitNotificationPreferencesValues must be replaced.
    this.unitNotificationPreferencesValues = {
      ...this.unitNotificationPreferencesValues
    };
  }
  async save() {
    this.buttonLoading = true;
    this.dataApi.track('Submit Checking Notifications', {
      feature: 'Checking Notifications',
      applet: 'Banking',
      page: 'Notifications',
      target: 'Done',
      unitToken: this.args.unitToken,
      ...getNotificationPreferencesForTracking(this.notificationTypeValue)
    });
    try {
      const {
        unitToken
      } = this.args;
      assert(typeof unitToken === 'string');
      const request = WorkflowRequest.create({
        flow: Flow.create({
          context: this.context,
          unitNotificationPreferences: Flow.UnitNotificationPreferencesFlow.create({
            unitToken
          })
        }),
        screens: [ScreenContainer.create({
          unitNotificationPreferencesScreen: ScreenContainer.UnitNotificationPreferencesScreen.create({
            preferences: {
              email: this.email,
              phoneNumber: this.phoneNumber,
              employmentToken: this.employmentToken,
              // cast `Mutable<UnitNotificationPreferencesValues>` back to `UnitNotificationPreferencesValues`
              unitNotificationPreferencesValues: this.unitNotificationPreferencesValues,
              unitNotificationPreferencesConfig: this.unitNotificationPreferencesConfig
            }
          })
        })]
      });
      await _classPrivateMethodGet(this, _populateUnitNotificationPreferences, _populateUnitNotificationPreferences2).call(this, request);
    } catch (e) {
      this.sentry.captureException(e);
      // Display server error banner if bb-frontend fails
      this.banners = [UiElement.BannerElement.create({
        text: this.intl.t('banking.checking.cardSettings.notificationPreferences.error.server'),
        style: UiElement.BannerElement.BannerStyle.CRITICAL
      })];
    }
    this.buttonLoading = false;
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "balancesWorkflowApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "emberMultipassfeClient", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "buttonLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "loadingError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "showSecureContactModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "email", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "employmentToken", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "notificationTypeOrder", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "notificationChannelOrder", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "notificationTypeTexts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "notificationChannelTexts", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "unitNotificationPreferencesValues", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "unitNotificationPreferencesConfig", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "banners", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "retryInitialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "retryInitialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditEmailClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEditEmailClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEditPhoneClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onEditPhoneClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onPreferenceChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onPreferenceChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype)), _class);
function _processScreens2(screens) {
  /**
   * Workflow end condition. If there are no screens or there is a completionStatusScreen,
   * it means that the workflow has finished.
   */
  if (screens.length === 0 || screens[0].completionStatusScreen !== null) {
    return this.args.dismiss();
  }

  /**
   * NOTE(cvu): The client only knows how to support UnitNotificationPreferenceScreen.
   * If there are other screens for some reason, we will ignore it
   */
  const screenContainer = screens.find(screenContainer => screenContainer.unitNotificationPreferencesScreen);
  assertInstanceOf(screenContainer, ScreenContainer);
  if (screenContainer) {
    const {
      unitNotificationPreferencesScreen
    } = screenContainer;
    const preferences = unitNotificationPreferencesScreen?.preferences;
    assertInstanceOf(preferences, UnitNotificationPreferences);
    if (preferences) {
      const {
        notificationTypeOrder,
        notificationChannelOrder,
        unitNotificationPreferencesValues,
        unitNotificationPreferencesConfig,
        email,
        phoneNumber,
        employmentToken,
        notificationTypeTexts,
        notificationChannelTexts
      } = preferences;
      this.email = email;
      this.phoneNumber = phoneNumber;
      this.employmentToken = employmentToken;
      this.notificationTypeOrder = notificationTypeOrder;
      this.notificationChannelOrder = notificationChannelOrder;
      this.notificationTypeTexts = notificationTypeTexts;
      this.notificationChannelTexts = notificationChannelTexts;
      this.unitNotificationPreferencesValues = unitNotificationPreferencesValues;
      this.unitNotificationPreferencesConfig = unitNotificationPreferencesConfig;
    }
    this.banners = unitNotificationPreferencesScreen?.banners ?? [];
  }
}
async function _populateUnitNotificationPreferences2(request) {
  const {
    flow,
    screens
  } = await this.balancesWorkflowApi.client.getWorkflow(request);
  this.context = flow?.context;
  _classPrivateMethodGet(this, _processScreens, _processScreens2).call(this, screens);
}
export { NotificationPreferences as default };